<script>
import bem from '@/utils/bem';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import UsersList from './UsersList.vue';

const b = bem('users-page');
export default {
  data() {
    return {
      title: 'Users',
    };
  },
  components: {
    PageHeader,
    UsersList,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <PageHeader :title="title"/>
  <UsersList />
</template>

<style src="./style.scss" scoped lang="scss"></style>
